export class TablePart {
  table: HTMLTableElement;
  container: HTMLElement;
  constructor(container, table){
    this.table = table;
    this.container = container;
  }
}
